module.exports = __webpack_public_path__ + "static/media/poudrebasement.9fd71a92.jpg";